/*
 * @Author: Q in 
 * @Date: 2025-03-11 14:27:53
 * @LastEditors: Q in 
 * @LastEditTime: 2026-02-28 10:33:30
 * @FilePath: /bf_web/src/utils/validate.js
 * @Description: 验证规则
 */
/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
	return /^(https?:|mailto:|tel:)/.test(path);
}

// 验证手机号
export function isValidateMobile(mobile) {
	const reg = /^1([38][0-9]|4[014-9]|[59][0-35-9]|6[2567]|7[0-8])\d{8}$/;
	return reg.test(mobile);
}

// 验证邮箱
export function isValidateEmail(email) {
	const reg = /\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/;
	return reg.test(email);
}

// 验证密码
export function isValidatePassword(password) {
	const reg = /^(\w){6,20}$/;
	return reg.test(password);
}

// 验证复杂密码 (至少包含一位小写字符和至少包含一个大写字母和至少包含一个数字且是6位数至20位数)
export function isValidateComplexPassword(password) {
	const reg = /^(?![a-z0-9]*$)(?![A-Z0-9]*$)(?![a-zA-Z]*$)[0-9a-zA-Z]{6,20}$/;
	return reg.test(password);
}

// 验证姓名
export function isRealName(name) {
	const reg = /^[\u00B7\u3007\u3400-\u9FFF\uE000-\uF8FF\uF900-\uFAFF\u{20000}-\u{2FFFF}\u{30000}-\u{3FFFF}]+$/u;
	return reg.test(name);
}

// 验证用户名 - 只能输入英文字符
export function isUserName(name) {
	const reg = /^[A-Za-z]+$/;
	return reg.test(name);
}

// 验证身份证号
export function isValidateIdCard(idCard) {
	const reg = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
	return reg.test(idCard);
}

/**
 * 判断当前环境是否为移动端
 * 综合检查：UserAgent、屏幕宽度、触摸支持、媒体查询
 * @returns {boolean} 是否为移动端
 */
export function isMobile() {
  // 避免SSR环境下window未定义报错
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return false
  }

  const userAgent = navigator.userAgent
  const isMobileUA = /(iPhone|iPod|iPad|Android|webOS|BlackBerry|Windows Phone|Mobile|mobile)/i.test(userAgent)

  const isSmallScreen = window.innerWidth <= 768
  const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0

  const isMobileMedia = window.matchMedia('(max-width: 768px) and (hover: none)').matches

  return isMobileUA || (isSmallScreen && hasTouch) || isMobileMedia
}

// 判断是否是微信端
export function isWechat() {
	const userAgent = navigator.userAgent.toLowerCase();
	const isWeixin = userAgent.indexOf('micromessenger') !== -1;
	return isWeixin ? true : false;
}

// 验证steam17位ID
export function isSteamId(steamId) {
	let isSteamId = '';
	if (steamId.length > 40 && steamId.split('/')) {
		isSteamId = steamId.split('/')[4];
	} else if (steamId.length > 17 && steamId.replace(/[ ]/g, '')) {
		isSteamId = steamId.replace(/[ ]/g, '');
	} else if (steamId.length == 17 && !steamId.replace(/[ ]/g, '')) {
		isSteamId = steamId.replace(/[ ]/g, '');
	} else if (steamId.length == 17) {
		isSteamId = steamId.replace(/[ ]/g, '');
	}
	if (/^[0-9]{17}$/.test(isSteamId)) {
		return isSteamId;
	} else {
		return '';
	}
}
